export enum PaymentReminderFileSortBy {
  UPLOADED_DATE_DESC = 'UPLOADED_DATE_DESC',
  UPLOADED_DATE_ASC = 'UPLOADED_DATE_ASC',
  REQUEST_NO_ASC = 'REQUEST_NO_ASC',
  REQUEST_NO_DESC = 'REQUEST_NO_DESC',
}

export enum PaymentReminderMailLogSortBy {
  CREATED_DATE_DESC = 'CREATED_DATE_DESC',
  CREATED_DATE_ASC = 'CREATED_DATE_ASC',
  SENT_DATE_DESC = 'SENT_DATE_DESC',
  SENT_DATE_ASC = 'SENT_DATE_ASC',
  STATUS_DESC = 'STATUS_DESC',
  STATUS_ASC = 'STATUS_ASC',
}

export enum PaymentReminderRemarksSortBy {
  CREATED_DATE_DESC = 'CREATED_DATE_DESC',
  CREATED_DATE_ASC = 'CREATED_DATE_ASC',
}

export enum PaymentReminderInvoiceSortBy {
  LATEST_RECENT_DATE = 'LATEST_RECENT_DATE', // createdAt desc - Most recent invoices first
  OLDEST_RECENT_DATE = 'OLDEST_RECENT_DATE', // createdAt asc - Oldest invoices first
  INVOICE_DATE_LATEST = 'INVOICE_DATE_LATEST', // invoiceDate desc - Latest invoice date first
  INVOICE_DATE_OLDEST = 'INVOICE_DATE_OLDEST', // invoiceDate asc - Oldest invoice date first
  DUE_DATE_LATEST = 'DUE_DATE_LATEST', // dueDate desc - Latest due date first
  DUE_DATE_OLDEST = 'DUE_DATE_OLDEST', // dueDate asc - Oldest due date first
}
